import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./ModalUpdateChatGroupPatients.style";
import * as P from "../../../../../utils/pipes";

// Hooks
import ZaiaReaction from "../../../../zaiaComponents/zaiaReaction";
import ZaiaButton from "../../../../zaiaComponents/zaiaButton";
import ZaiaModalResponseContent from "../../../../zaiaComponents/zaiaModalResponseContent";
import ZaiaInput from "../../../../zaiaComponents/zaiaInput";
import ZaiaRoundInput from "../../../../zaiaComponents/zaiaRoundInput";
import { QUERY_GET_USER_BY_PROCESS, QUERY_GET_USERS } from "../../../../../graphql/queries/User";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import ZaiaImage from "../../../../zaiaComponents/zaiaImage";
import Popup from "reactjs-popup";
import ProcessName from "../../../shared/processName";
import { QUERY_GET_DOCTORS_DATA } from "../../../../../graphql/queries/Doctor";
import useDoctorData from "../../../../../hooks/useDoctorData";
import { MUTATION_INSERT_ROLE_AND_DOCTOR_TO_PROCESS_ROLE, MUTATION_INSERT_DOCTOR_TO_PROCESS_ROLE, MUTATION_DELETE_DOCTOR_TO_PROCESS_ROLE_BY_IDS } from "../../../../../graphql/mutations/Doctor";
import { QUERY_GET_PROCESS_ROLES_BY_ID } from "../../../../../graphql/queries/Process";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput";
import DoctorItem from "./patientItem";
import { GET_DOCTOR_TO_PROCESS_ROLE } from "../../../../../graphql/queries/DoctorToProcessRole";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import { MUTATION_DELETE_PATIENT_TO_CHAT, MUTATION_INSERT_PATIENT_TO_CHAT } from "../../../../../graphql/mutations/Chat";
import PatientItem from "./patientItem";


// Assets
const eventsCalendarEmpty = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/no-results.svg`;
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

function ModalUpdateChatGroupPatients({
  chatGroup,
  setModalActive
}) {

  const { t, i18n: { language } } = useTranslation("global");
  const {doctorData} = useDoctorData();

  const [currentPatients, setCurrentPatients] = useState([]);
  const [availablePatients, setAvailablePatients] = useState([]);
  const [patientsToAdd, setPatientsToAdd] = useState([]);
  const [patientsToRemove, setPatientsToRemove] = useState([]);  

  const [insertPatientsToChat, { loading: insertPatientsToChatLoading }] = useMutation(MUTATION_INSERT_PATIENT_TO_CHAT);
  const [deletePatientsToChat, { loading: deletePatientsToChatLoading }] = useMutation(MUTATION_DELETE_PATIENT_TO_CHAT);  
  
  const { data: usersByProcessData, loading: usersByProcessDataLoading, error: usersByProcessDataError, refetch: refetchUsersByProcessData } = useQuery(QUERY_GET_USER_BY_PROCESS,
    {
      variables: {
        processId: chatGroup.userToProcess.processId
      }
    }
  );

  useEffect(() => {
    refetchUsersByProcessData();
  }, []);  

  useEffect(() => {        
    const currentPatientsTemp = chatGroup.personToChats?.map(personToChat => {
      return {
        id: personToChat.id,
        name: `${personToChat.user?.name} ${personToChat.user?.lastname}`,
        value: personToChat.userId
      };
    });

    setCurrentPatients(currentPatientsTemp || []);

    const availablePatientsTemp = usersByProcessData?.user?.filter((patient) => !currentPatientsTemp?.some(current => current.value === patient.id)).map(patient => {
      return {
        id: null,
        name: `${patient.name} ${patient.lastname}`,
        value: patient.id
      };
    });
    setAvailablePatients(availablePatientsTemp || []);

  }, [usersByProcessData]);
  

  const [formSuccess, setFormSuccess] = useState(null); 
  const [inputText, setInputText] = useState(''); 

  const getFilterText = (text) => {
    return inputText 
      ? String(P.removeAccent(text)).toLowerCase().includes(P.removeAccent(inputText).toLowerCase())
      : true
  }

  const handleRemoveDoctors = async () => {
    try {
      await deletePatientsToChat({
        variables: {
          personToChatIds: patientsToRemove,
        },
      });
      setFormSuccess(true);
    } catch (err) {
      console.log(err);
      setFormSuccess(false);
    }
  }

  const handleSubmit = () => {

    if(patientsToAdd.length > 0) {
      handleAddDoctors();
    }

    if(patientsToRemove.length > 0) {
      handleRemoveDoctors();
    }
  }

  const handleAddDoctors = async () => {    
    try {

      await insertPatientsToChat({
        variables: {
          personToChat: patientsToAdd
        },
      });
      
      setFormSuccess(true);
    } catch(err) {
      console.log(err);
      setFormSuccess(false);
    }
  }

  useEffect(() => {    

    const doctorToAddTemp = currentPatients.filter(patient => {

      return !chatGroup.personToChats?.some(d => d.user?.id === patient?.value);
    }).map(patient => {    
      
      return {
        chatGroupId: chatGroup.id,
        userId: patient.value      
      }
    });        

    setPatientsToAdd(doctorToAddTemp || []);
  }, [availablePatients]);

  useEffect(() => {
    const patientsToRemoveTemp = chatGroup.personToChats?.filter(personToChat => {
      return !currentPatients.some(current => current?.value === personToChat?.user?.id)
    }).map(patient => patient.id);

    setPatientsToRemove(patientsToRemoveTemp || []);
  }, [currentPatients]);

  const handleRemovePatient = (patient) => {
    setCurrentPatients(currentPatients.filter(d => d !== patient));
    setAvailablePatients([...availablePatients, patient]);
  }

  const handleAddPatient = (patient) => {   
    setAvailablePatients(availablePatients.filter(d => d !== patient));
    setCurrentPatients([...currentPatients, patient]);
  }

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.keyCode === 27) {
        setModalActive(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);

  console.log("current Patients", currentPatients);
  console.log("available Patients", availablePatients);
  

  if(
    insertPatientsToChatLoading ||
    deletePatientsToChatLoading ||
    usersByProcessDataLoading
  ) 
    return(
      <S.ModalUpdateChatGroupPatients>
        <div className="modal-background">
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaReaction
              widthimg={"150px"}
              zaiaImg={logoZaiaLoading}
              padding={"200px 0px"}
            />
          </div>
        </div>
      </S.ModalUpdateChatGroupPatients>
    )

  if(formSuccess)
    return(
      <S.ModalUpdateChatGroupPatients>
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaModalResponseContent
              button1={() => setModalActive(null)}
              formSuccess={formSuccess}
              button1Text={t("globally.done")}
              title={t("profile.invitationManagement.sharePatientDataSuccess")}
            />
          </div>
        </div>
      </S.ModalUpdateChatGroupPatients>
    )

  if(formSuccess === false)
    return(
      <S.ModalUpdateChatGroupPatients>
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaModalResponseContent
              button1={() => setModalActive(null)}
              formSuccess={formSuccess}
              title={t("globally.errorForm")}
              subtitle={t("profile.invitationManagement.sharePatientDataError")}
              button1Text={t("globally.accept")}            
            />
          </div>
        </div>
      </S.ModalUpdateChatGroupPatients>
    )

  return (
    <S.ModalUpdateChatGroupPatients>
      <div className="modal-background" onClick={() => setModalActive(false)}>
      </div>
      <div className="modal-container">
        <div className="header">
          <div className="header__text">
            <div className="header__title">{t("chat.settingsChat.editParticipantsChat")}</div>
            {/* <div className="header__patient">
              <ZaiaImage
                size={24}
                img={patientInfo.user.picture}
                rounded={true}
              />
              <div className="header__patient-name">{`${patientInfo.user.name} ${patientInfo.user.lastname}`}</div>
              <div className="header__patient-process">{P.dataTranslation(patientInfo?.process?.processName, language)}</div>
            </div> */}
          </div>
          <div className="header__action" onClick={() => setModalActive(false)}>
            <i className="header__action-icon icon zaia-icono-cerrar"/>
          </div>
        </div>
        <div className="modal-content">
          <div className="modal-content__left">
            <div className="devices-linked">
              <div className="devices-linked__title">
                <div className="title">
                  {t("chat.settingsChat.patientsInChat")}
                </div>
              </div>
              <div className="devices-linked__list">
                { currentPatients.length === 0 
                  && <div className="devices-linked__list-empty">
                    {t("chat.settingsChat.noPatients")}
                  </div>
                }
                { 
                  currentPatients
                  .map((patient, index) => {
                    return (   
                      <div
                        key={index}
                        onClick={() => {
                          handleRemovePatient(patient);
                        }}
                      >
                        <PatientItem
                          patient={patient}
                          added={true}
                        />
                      </div>
                    )
                  }
                  )
                }
              </div>
            </div>
          </div>
          <div className="modal-content__right">
            <div className="devices-available">
              <div className="devices-available__title">
                <div className="title">
                  {t("chat.settingsChat.patientsAvailable")}
                </div>
                <div className="searcher">
                  <FlorenzSearchInput
                    placeholder={t("globally.search")}
                    forWhiteBackgroud={true}
                    getText={(text) => setInputText(text)}
                    borderanimation={false}
                  />
                </div>
              </div>
              <div className="devices-available__list">
                { usersByProcessDataLoading
                  ? <div className="devices-available__list-loading">
                      <ZaiaReaction
                        widthimg={"100px"}
                        zaiaImg={logoZaiaLoading}
                        padding={"100px 0px"}
                      />
                    </div>
                  : usersByProcessDataError
                    ? <div className="devices-available__list-error">
                        <ZaiaReaction
                          widthimg={"150px"}
                          zaiaImg={logoZaiaAlert}
                          padding={"100px 0px"}
                          text={t("chat.settingsChat.errorLoadingPatients")}
                        />
                      </div>
                    : availablePatients.length === 0
                      ? <div className="devices-available__list-empty">
                          <ZaiaReaction
                            widthimg={"150px"}
                            zaiaImg={eventsCalendarEmpty}
                            padding={"100px 0px"}
                            text={t("chat.settingsChat.noPatientsAvailable")}
                          />
                        </div>
                      : availablePatients?.map((patient, index) => 
                        (
                          getFilterText(`${patient.name}`)
                        ) &&
                        (
                          <div
                            key={index}
                            onClick={() => {
                              handleAddPatient(patient);
                            }} 
                          >
                            <PatientItem
                              patient={patient}
                              added={false}
                            />  
                          </div>
                        )
                      )
                }
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="button-container">
            <FlorenzButton
              typeStyle={"secondaryWhite"}
              size="s"
              text={t("globally.cancel")}
              widthComplete={true}
              onClick={() => {
                setModalActive(false)
              }}
            />
          </div>
          <div className="button-container">
            <FlorenzButton
              disabled={
                patientsToAdd.length === 0 && patientsToRemove.length === 0
              }
              size="s"
              typeStyle={"success"}
              text={t("globally.save")}
              widthComplete={true}
              icon={
                (patientsToAdd.length === 0 && patientsToRemove.length === 0) && "zaia-i-lock-chat"
              }
              onClick={() => {
                handleSubmit()
              }}
            />
          </div>
        </div>
      </div>
    </S.ModalUpdateChatGroupPatients>
  );
}


export default ModalUpdateChatGroupPatients;
